import { createEnv, envString, envBoolean, z } from '@percent/utility'

export const env = createEnv({
  schema: {
    NX_PUBLIC_REACT_APP_ENV: envString(),
    NX_PUBLIC_USE_SENTRY_LOGGER: envBoolean().optional(),
    NX_PUBLIC_WPG_ADDRESS: envString(),
    NX_PUBLIC_API_URL: envString(),
    NX_PUBLIC_TEST_MODE: envBoolean().optional(),
    NX_PUBLIC_APP_URL: envString(),
    NX_PUBLIC_POSTHOG_API_KEY: z.string().optional(),
    NX_PUBLIC_RECAPTCHA_SITE_KEY: z.string().optional(),
    // A JSON map of PostHog flag key -> boolean, applied as local flag overrides (highest
    // precedence). Set only in the gitignored `.env.local` for local testing; never in
    // committed/deployed config, so it can't affect a real environment. Malformed JSON is
    // ignored. e.g. NX_PUBLIC_FEATURE_FLAG_OVERRIDES={"pd_insights_ai_chat":true}
    NX_PUBLIC_FEATURE_FLAG_OVERRIDES: envString().optional()
  }
})
